import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Content = styled.div`
	display: flex;
	min-height: 221px;
	max-height: 514px;
`;
